const SELECTOR = '[data-animate]';
const VISIBLE_ATTR = 'data-animate-visible';

function revealAll() {
  document.querySelectorAll(SELECTOR).forEach((el) => el.setAttribute(VISIBLE_ATTR, ''));
}

function init() {
  const elements = document.querySelectorAll(`${SELECTOR}:not([${VISIBLE_ATTR}])`);
  if (!elements.length) return;

  // In the theme editor show everything immediately so merchants aren't confused
  if (window.Shopify?.designMode) {
    revealAll();
    return;
  }

  // Respect prefers-reduced-motion
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    revealAll();
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.setAttribute(VISIBLE_ATTR, '');
        observer.unobserve(entry.target);
      });
    },
    {
      threshold: 0.1,
      rootMargin: '0px 0px -40px 0px',
    }
  );

  elements.forEach((el) => observer.observe(el));
}

// Re-init when a section is added/reloaded in the theme editor
document.addEventListener('shopify:section:load', init);

init();
